import { JSONSchema6 } from "json-schema";

const getCheckoutSessionSchema: JSONSchema6 = {
    title: "Get Checkout Session",
    description: "Get Checkout Session details includes buyer info, payment instrument details, and shipping address. Shipping address will only be returned if Checkout Session has PayAndShip product type. Use this operation to determine if checkout was successful after the buyer returns from the AmazonPayRedirectUrl to the specified checkoutResultReturnUrl.",
    properties: {
        "pathParam": {
            title: "checkoutSessionId",
            type: "string",
        }
    },
    required: ["pathParam"]
}

export default getCheckoutSessionSchema